import { NgModule } from '@angular/core';
import { IonicComponentsModule } from '@app/shared/modules/ionic-components/ionic-components.module';
import { TermsManagerService } from './terms-manager.service';

@NgModule({
  providers: [IonicComponentsModule, TermsManagerService],
})
export class TermsManagerModule {}
